import { Collection, IFindCollectionFilter, PublishStatusEnum, User } from 'lingo2-models';

export type CollectionTab = 'published' | 'private' | 'draft' | 'moderation' | 'purchased' | 'archive';

export interface ICollectionTab {
  id: CollectionTab;
  title: string;
  stub: {
    tutor: string;
    student: string;
    stub_guest: string;
  };
  filter: Partial<IFindCollectionFilter>;
}

export enum CollectionUserActionEnum {
  /** Могу посмотреть в модалке */
  preview = 'preview',

  /** Могу изменить общие сведения */
  edit = 'edit',

  /** Могу опубликовать */
  publish = 'publish',

  /** Могу снять с публикации */
  unpublish = 'unpublish',

  /** Могу архивировать */
  archive = 'archive',

  /** Могу восстановить из архива */
  restore = 'restore',
}

/** TODO после отладки перенести на бэк */
export class CollectionAccess {
  // TODO ? protected purchase: CollectionPurchase,
  constructor(protected user: User, protected collection: Collection) {}

  public get can(): { [key in CollectionUserActionEnum]: boolean } {
    return this.formatCans();
  }

  // ----------

  protected formatCans(): { [key in CollectionUserActionEnum]: boolean } {
    return {
      /** Могу посмотреть в модалке */
      [CollectionUserActionEnum.preview]: this.canPreview,

      /** Могу изменить общие сведения */
      [CollectionUserActionEnum.edit]: this.canEdit,

      /** Могу опубликовать */
      [CollectionUserActionEnum.publish]: this.canPublish,

      /** Могу снять с публикации */
      [CollectionUserActionEnum.unpublish]: this.canUnpublish,

      /** Могу архивировать */
      [CollectionUserActionEnum.archive]: this.canArchive,

      /** Могу восстановить из архива */
      [CollectionUserActionEnum.restore]: this.canRestore,
    };
  }

  // ----------
  /** Могу посмотреть в модалке */
  protected get canPreview(): boolean {
    return this.isPublished || this.isOnModeration || this.isPurchased;
  }

  /** Могу изменить общие сведения */
  protected get canEdit(): boolean {
    return !this.isInArchive && !this.isOnModeration && !this.isPurchased;
  }

  /** Могу опубликовать */
  protected get canPublish(): boolean {
    return this.isValid && this.isDraft && !this.isPurchased;
  }

  /** Могу снять с публикации */
  protected get canUnpublish(): boolean {
    return this.isValid && this.isPublished && !this.isPurchased;
  }

  /** Могу архивировать */
  protected get canArchive(): boolean {
    return !this.isInArchive && !this.isOnModeration;
  }

  /** Могу восстановить из архива */
  protected get canRestore(): boolean {
    return this.isInArchive;
  }

  protected get isValid(): boolean {
    return true;
  }

  protected get isPublished(): boolean {
    return this.collection?.publish_status === PublishStatusEnum.published;
  }

  protected get isDraft(): boolean {
    return this.collection?.publish_status === PublishStatusEnum.draft;
  }

  protected get isOnModeration(): boolean {
    return this.collection?.publish_status === PublishStatusEnum.moderation;
  }

  protected get isInArchive(): boolean {
    return this.collection?.publish_status === PublishStatusEnum.archive;
  }

  protected get isPurchased(): boolean {
    return !!this.collection?.visit_info?.licensed;
  }
}
